var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.logo)?_c('div',[_c('img',{class:_vm.$style['image'],attrs:{"src":_vm.logo,"alt":"logo"}})]):_vm._e(),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }